import { Category } from '../types/product'

interface CategoryAssignmentPickerProps {
  allCategories: Category[]
  assignedCategoryIds: Set<number>
  onChange: (categoryId: number, assigned: boolean) => void
  inFlightCategoryIds?: Set<number>
  disabled?: boolean
  helperText?: string
}

const CategoryAssignmentPicker = ({
  allCategories,
  assignedCategoryIds,
  onChange,
  inFlightCategoryIds,
  disabled = false,
  helperText,
}: CategoryAssignmentPickerProps) => {
  const sorted = [...allCategories].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }),
  )

  if (sorted.length === 0) {
    return (
      <p className="text-sm text-gray-500 italic">
        No categories configured.
      </p>
    )
  }

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        {sorted.map((category) => {
          const checked = assignedCategoryIds.has(category.id)
          const inFlight = inFlightCategoryIds?.has(category.id) ?? false
          return (
            <div key={category.id} className="flex items-center">
              <input
                type="checkbox"
                id={`category-${category.id}`}
                checked={checked}
                disabled={disabled || inFlight}
                onChange={(e) => onChange(category.id, e.target.checked)}
                className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded disabled:opacity-60"
              />
              <label
                htmlFor={`category-${category.id}`}
                className="ml-2 block text-sm text-gray-700"
              >
                {category.name}
              </label>
            </div>
          )
        })}
      </div>
      {helperText && <p className="text-xs text-gray-500">{helperText}</p>}
    </div>
  )
}

export default CategoryAssignmentPicker
